import React from 'react';

import * as AudioConstants from './constants';
import * as D from './deps';
import AudioReducer from './reducer';
import getHandlers from './sagas/watchers';
import * as AudioUtils from './utils';

export default D.createDomainModule({
  name: AudioConstants.DOMAIN_NAME,
  components: {
    WakeLock: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_wakelock" */ './components/WakeLock/WakeLock')
          }
        />
      );
    },
  },
  reducer: AudioReducer,
  utils: AudioUtils,
  constants: AudioConstants,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(getHandlers());
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
